module.exports = __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmWUlfChc4EsA.188b3976.woff2";